<template>
  <div class="loginpage">
    <main>
      <section id="login-form" class="al-flex">
        <div id="login-panel">
          <header class="logo">
            <img src="@/assets//images/logo/logo_wide.png" class="cursor-pointer logo-img"
                 alt="Authorize Local Logo"/>
            <hr style="border: none; border-top: 1px solid #C8D2D2; margin: 0 40px;">
          </header>
          <section class="login-title-section">
            <div class="login-title">Login to your account</div>
          </section>
          <section class="input-area">
            <label for="email">Email:</label>
            <input type="email" id="email" placeholder="Enter your email"
                   v-model="email"
                   @keyup.enter="login">
            <label for="password">Password:</label>
            <input type="password" id="password" placeholder="Enter your password"
                   v-model="password"
                   @keyup.enter="login">
            <div class="div-input-checkbox">
              <input type="checkbox" class="input-checkbox"><span class="remember-me">Remember me</span>
              <a href="/reset-password" class="forgot-your-password">Forgot your password</a>
            </div>

            <div>
              <button class="login-button al-button" @click="login">LOGIN</button>
              <button @click="redirectTo('https://authorizelocal.com/pricing')" class="singup-button al-button">SIGN UP</button>
            </div>
          </section>
          <!--          <footer class="login-options">
                      <p class="forgot"><a href="/reset-password">Forgot Password?</a></p>
                    </footer>-->
        </div>
        <div class="credentials">© 2022 | <a href="https://authorizelocal.com">Authorize Local</a></div>
      </section>
    </main>
  </div>

</template>

<script>

import Logo from '../../layouts/components/Logo'

export default {
  data () {
    return {
      email: '',
      password: '',
      checkbox_remember_me: false,
      inputIsVisible: false
    }
  },
  metaInfo () {
    return {
      title: 'Login',
      titleTemplate: '%s - AuthorizeLocal',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Login to your account'
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'Local SEO Solutions'
        }
      ]
    }
  },
  components: {
    Logo
  },
  mounted () {
  },
  methods: {
    redirectTo (url) {
      window.location.href = url
    },
    emailClick () {
    },
    login () {
      const loginuser = {
        email: this.email, //'serkan.erdinc@asay.com.tr',
        password: this.password
      }

      this.$store.dispatch('loginUser', loginuser)
        .then((response) => {
          console.log('success')
          if (this.checkbox_remember_me) {
            localStorage.setItem('email', this.email)
            localStorage.setItem('password', this.password)
          }
          localStorage.setItem('check', this.checkbox_remember_me)

          this.$vs.notify({
            title: 'Successful login',
            text: response.data.message,
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success'
          })
          this.$router.push({name: 'home'})
        })
        .catch(error => {
          this.$vs.loading.close()
          console.log('error')
          console.log(error)
          this.$vs.notify({
            title: 'Error',
            text: error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })

        })
    }
  }
}
</script>

<style lang="scss">
#login-panel2 {
  width: 473px;
  height: 713px;
  flex-shrink: 0;
  border-radius: 20px;
  background: #FFF;
}

.login-title {
  color: var(--Main-Color-Main-80, #006495);
  font-variant-numeric: lining-nums proportional-nums;
  /* Heading Styles/H2 */
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 40px; /* 142.857% */
  padding: 0 75px;
  min-width: 400px;
}

.login-title-section {
  margin-bottom: 0px !important;
}

.input-area {
  padding: 10px 40px;
}

.input-area > label {
  color: var(--Main-Color-Main-100, #003451);
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
}

.input-area > input {
  padding: 20px;
  box-shadow: none;
  -webkit-box-shadow: none;
  border: none;
  margin-bottom: 20px;
  margin-top: 10px;
  display: flex;
  /* width: 401px; */
  padding: 12px;
  align-items: center;
  gap: 5px;
  border-radius: 12px;
  border: 1px solid var(--Cold-Gray-Cold-Gray-30, #AEB8B8);
  margin-bottom: 20px;
}

.login-button {
  border-radius: 12px;
  background: var(--Main-Color-Main-80, #006495) !important;
  margin-bottom: 15px !important;
}

.login-button:hover {
  border-radius: 12px;
  background: var(--Main-Color-Main-100, #003451) !important;
}

.singup-button {
  border-radius: 12px;
  background: var(--Primery-Primery-40, #F39844) !important;
  margin-bottom: 15px !important;
}

.singup-button:hover {
  border-radius: 12px;
  background: var(--Primery-Primery-Main-50, #F08028) !important;
}
.div-input-checkbox {
  padding-bottom: 55px;
}
.input-checkbox {
  float: left;
  width: auto !important;
  background-color: transparent !important;
  margin-right: 5px;
  margin-top: 5px;
  border-radius: 4px;
  border: 1px solid #AEB8B8;
  background: #FFF0;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.remember-me {
  font-size: 13px !important;
  color: #272E35;
  font-feature-settings: 'clig' off, 'liga' off;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.2px;
  float: left !important;
  width: auto
}
.forgot-your-password {
  float: right !important;
  font-size: 12px !important;
  color: #F08028;
  font-variant-numeric: lining-nums proportional-nums;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 171.429% */
}
.logo-img {
  padding: 40px 60px 20px 60px;
}
</style>
